import { TranslateLoader } from '@ngx-translate/core';

import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ApiPaths } from '@gah-core/constants/api-paths.enum';
import { environment } from '@environments/environment';
import { catchError, map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { Base64 } from 'js-base64';

export class CustomLoader implements TranslateLoader {
  constructor(private http: HttpClient, private log: NGXLogger) {}
  getTranslation(langCountry: string): Observable<any> {
    return this.http
      .get<any>(
        `${environment.apiUrl}${
          ApiPaths.GetTranslationFile
        }?localeCode=${langCountry?.toUpperCase()}`
      )
      .pipe(
        map((res) => {
          return JSON.parse(Base64.decode(res.serviceResult));
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }
}
